import { LokijsService } from 'src/app/services/database/lokijs.service';
import { UrlEndpoints } from './../../definitions/url-endpoints';
import {HttpClient} from '@angular/common/http';

import {Injectable} from '@angular/core';

import {of as observableOf,  Observable } from 'rxjs';
import {delay} from 'rxjs/operators';
import { ConfigurationService } from '../configuration.service';

@Injectable()
export class AuthenticationService {
    public authTokenStale = 'stale_auth_token';
    public authTokenNew  = 'new_auth_token';
    public currentToken: string;

    constructor(private httpClient: HttpClient,
      private configurationService: ConfigurationService,
      private urlEndpoints: UrlEndpoints,
      private loki: LokijsService) {
       this.currentToken = this.authTokenStale;
    }

    getAuthToken() {
        return this.currentToken;
    }

    getAuthentication() {
        console.log('getting authenticated');
        const configuration = this.configurationService.getConfiguration();
        const apiKey = {'apikey': configuration.apikey};

        /*
        return new Promise((resolve, reject) => {
                this.httpClient.post(this.configurationService.buildUrl( this.urlEndpoints.authenticationPostEndPoint )
                , apiKey).map( res => res).subscribe(data => {
                    console.log('this is the token');
                    console.log(data);
                    resolve(data);
                });
        });
        */

        return this.httpClient.post(this.configurationService.buildUrl( this.urlEndpoints.authenticationPostEndPoint )
        , apiKey).toPromise();
    }

    getAuthenticationObservable(): Observable<string> {
        console.log('getting authenticated');
        const configuration = this.configurationService.getConfiguration();
        const apiKey = {'apikey': configuration.apikey};

        console.log('Running return observableOf');

        return this.httpClient.post(this.configurationService.buildUrl( this.urlEndpoints.authenticationPostEndPoint ),
         apiKey, {responseType: 'text'}).pipe(delay(1000));
    }

}
